// extracted by mini-css-extract-plugin
export default {"container":"DialogFooter--container--d684eb","fullWidth":"DialogFooter--fullWidth--9fd077","shadow":"DialogFooter--shadow--044d82"};